import React from 'react';

import Button from '@material-ui/core/Button';

import * as classes from './BobWorkbookModeButton.module.css';

const BobWorkbookModeButton = ({
    handleWorkbookMode,
    workbookMode,
    ...props
}) => {

    return (
        <Button
            variant={workbookMode ? 'outlined' : 'contained'}
            size="medium"
            className={workbookMode ? classes.WorkbookContainedMode : classes.WorkbookOutlinedMode}
            onClick={() => handleWorkbookMode()}
        >
            Workbook Mode
        </Button>
    );
};

export default BobWorkbookModeButton;
